<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

import SetUp from "@/components/i18n/SetUp.vue";

export default {
  name: 'App',
  components: {
    SetUp
  }
}
</script>

